import React, { Component } from 'react';

export default class Adminaccount extends Component {
    state = {
        password: ''
    }

    goToskills = () => {
        window.location.href = '/add-skills'
    }
    render() {
        return <div className='admin-verify'>
            <div className='verify-account'>
                <h1 className='text-center'>Account Information</h1>
                <div className='verify-form' >
                    <div className="form-group" >
                        <label>Set a password</label>
                        <div className="has-search mt-1"  >
                            <span className="form-control-feedback" >
                                <img src="/images/lock-icon.svg" alt='' />
                            </span>
                            <input type="password" className="form-control" autoComplete='off' onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                        </div>
                    </div>
                    <div className="form-group" >
                        <label>Company Website(Optional)</label>
                        <div className="has-search mt-1"  >
                            <span className="form-control-feedback" >
                                <img src="/images/site-icon.svg" alt='' />
                            </span>
                            <input type="text" className="form-control" autoComplete='off' onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                        </div>
                    </div>
                    <div className="form-group" >
                        <label>Logo</label>
                        <div className='upload mt-1'>

                            <span> <img src='/images/upload.svg' alt='' />Upload&nbsp;
                                <input type='file' ref="uploadImg" className='file-upload'
                                    name="selectedFile" accept="image/png, image/jpeg" />
                            </span>
                        </div>
                    </div>
                    <div className='form-group' >
                        <button className='form-control button-color' style={{ borderRadius: 2, fontWeight: 500 }} onClick={() => this.goToskills()}>Next</button>
                    </div>
                </div>
            </div>

            <div className='admin-images'>
                <div className='float-left'>
                    <img src='/images/image4.svg' alt='' />
                </div>
                <div className='float-right'>
                    <img src='/images/image5.svg' alt='' />
                </div>
            </div>
        </div>;
    }
}
